import styled from "styled-components";

export const InputFormWrapper = styled.div`
  margin-top: 14px;
`;

export const WelfareTips = styled.div`
  display: inline-flex;
  gap: 8px;
`;

export const Gift = styled.div`
  background: rgba(251, 107, 74, 0.1);
  border-radius: 4px;
  padding: 4px 14px 4px 10px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  svg {
    height: 14px;
  }
  .coupon-space {
    margin: 0 3px;
  }
  .space {
    margin: 0 10px;
    color: rgba(255, 255, 255, 0.24);
  }
`;
